import { useState, useEffect } from 'react';
import { Building2, MapPin, Users } from 'lucide-react';
import axios from 'axios';

const API = '/api';

const StatsCounter = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/stats`);
        setStats(response.data);
      } catch (error) {
        console.error('Stats error:', error);
      }
      setLoading(false);
    };
    fetchStats();
  }, []);

  if (loading || !stats) {
    return null;
  }

  // Round down to the nearest 10 so hero stats don't wiggle between
  // renders (one business added, banner ticks from 324 to 325). The "+"
  // suffix already implies "at least"; keep Countries exact since it's a
  // small discrete number where rounding misrepresents coverage.
  const floorTen = (n) => Math.floor((n || 0) / 10) * 10;

  const statItems = [
    {
      icon: Building2,
      value: floorTen(stats.businesses),
      label: 'Listed Businesses',
      color: 'text-orange-500',
      showPlus: true,
    },
    {
      icon: MapPin,
      value: stats.countries || 0,
      label: 'Countries',
      color: 'text-blue-500',
      showPlus: false,
    },
    {
      icon: Users,
      value: floorTen(stats.meetup_groups),
      label: 'Meetup Groups & Walks',
      color: 'text-purple-500',
      showPlus: true,
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-4 md:gap-8" data-testid="stats-counter">
      {statItems.map((item, idx) => (
        <div key={idx} className="text-center">
          <div className="flex justify-center mb-2">
            <item.icon className={`w-6 h-6 md:w-8 md:h-8 ${item.color}`} />
          </div>
          <div className="text-2xl md:text-4xl font-bold text-foreground">
            {item.value.toLocaleString()}{item.showPlus ? '+' : ''}
          </div>
          <div className="text-xs md:text-sm text-muted-foreground">
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCounter;
